exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".e-timeline { position: relative; padding-left: 20px; }\n.e-timeline::before {\n  content: ''; position: absolute; left: 7px; top: 0; bottom: 0; width: 2px; background: #e6e8ea;\n}\n.e-timeline-item { position: relative; padding-bottom: 20px; }\n.e-timeline-marker {\n  position: absolute; left: -20px; top: 4px; width: 12px; height: 12px; border-radius: 50%;\n  background: #fff; border: 2px solid #526069; z-index: 1;\n}\n.e-timeline-marker.success { border-color: #4caf50; background: #4caf50; }\n.e-timeline-marker.warning { border-color: #f2a654; background: #f2a654; }\n.e-timeline-time { font-size: 12px; color: #888; margin-bottom: 4px; }\n.e-timeline-title { font-size: 14px; font-weight: bold; color: #37474f; }\n.e-timeline-desc { font-size: 13px; color: #526069; margin-top: 4px; }\n.e-timeline-actor { font-size: 12px; color: #37474f; margin-top: 4px; font-style: italic; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/e-timeline/e-timeline.component.css
// module id = ../../../../../src/app/components/e-timeline/e-timeline.component.css
// module chunks = 3